<template>
  <div class="main">
    <div style="height: 5px"></div>
    <div class="options_div">
      <div @click="change_pwd" class="chage_pwd">
        <span class="iconfont iconquanxianmiyao"></span> 修改登录密码
      </div>
    </div>
    <div class="sys_select2">
      <div class="title_div2">
        <div class="title_icon"></div>
        帐号安全
      </div>
      <div class="login_device">
        <div class="login_device_title">
          1、帐号当前状态：
          <br />
          <span style="color: #ccc; font-size: 12px; margin-left: 20px"
            >为安全起见，同一个平台，尽量保留一个登录状态，可手动把认为不安全的踢下线！</span
          >
        </div>

        <div class="login_device_margin">
          <Table stripe :columns="columns" :data="account_list" size="small">
            <template #action="{ row }">
              <Button
                size="small"
                style="font-size: 10px"
                @click="click_del_token(row)"
                type="error"
                >踢下线</Button
              >
            </template>
          </Table>
        </div>
      </div>

      <div class="login_device">
        <div class="login_device_title">
          2、帐号登录记录：
          <br />
          <!-- <span style="color:#ccc;font-size: 12px;margin-left:20px">为安全起见，同一个平台，只会保留一个登录状态，超过将被挤下线！</span> -->
        </div>

        <div>
          <Table
            stripe
            height="300"
            :columns="record_columns"
            :data="record_list"
            size="small"
          >
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page, get_browser_id } from "@/utils/http.js";

export default {
  name: "user_safe",
  data() {
    return {
      columns: [],
      account_list: [],
      record_columns: [],
      record_list: [],
    };
  },
  mounted() {},
  methods: {
    open() {
      this.get_account_status_list();
      this.get_login_record_list();
    },

    //获取登录记录
    get_login_record_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/login_record",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.record_list = res.data.record_list;
            this.record_columns = res.data.columns;
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    del_toekn_request(platform, login_time) {
      var that = this;
      var obj = {
        login_time: login_time,
        platform: platform,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/del_token",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.info(res.msg);

            setTimeout(function () {
              that.get_account_status_list();
            }, 1000);

            // that.sys_list = res.data.sys_list
            // that.user_info = res.data.user_info
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    click_del_token(row) {
      var that = this;
      this.$Modal.confirm({
        title: "操作提示",
        content: "<p>操作后，对应的平台帐号登录状态将失效，需要重新登录，是否继续？</p>",
        onOk: () => {
          that.del_toekn_request(row.platform, row.login_time_tsp);
        },
        onCancel: () => {},
      });
    },

    get_account_status_list() {
      console.log("获取系统列表");
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/account_status_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            var account_list = res.data.account_list;
            this.account_list = account_list;
            this.columns = res.data.columns;
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    change_pwd() {
      open_new_page("/user/change_pwd");
    },
  },
};
</script>

<style scoped>
.login_device_title {
  font-size: 13px;
  color: #333;
  margin-bottom: 10px;
}

.login_device_margin {
  max-height: 250px;
  overflow: auto;
}
.title_div2 {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 15px;
  padding-bottom: 10px;
  margin-bottom: 0px;
  border-bottom: 1px solid #f5f5f5;
}

.title_icon {
  border-radius: 3px;
  margin-right: 10px;
  height: 15px;
  width: 8px;
  background: #0466dd;
}

.options_div {
  background: #fff;
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
}

.chage_pwd:hover {
  box-shadow: 0 0 3px #969696;
}
.chage_pwd {
  cursor: pointer;
  width: 150px;
  border-radius: 10px;
  padding: 10px 20px;
  background: #0466dd;
  color: #fff;
}

.main {
  width: calc(100vw - 120px);
  min-height: 100vh;
  background: #ececec;
}

.sys_select2 {
  margin: 10px;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
}
</style>
